import { render } from "./LessonDetail.vue?vue&type=template&id=46f01cb6&scoped=true"
import script from "./LessonDetail.vue?vue&type=script&lang=js"
export * from "./LessonDetail.vue?vue&type=script&lang=js"

import "./LessonDetail.vue?vue&type=style&index=0&id=46f01cb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f01cb6"]])

export default __exports__